
export const getCompositionParts = (item, type) => {
  return item &&
    item.productData &&
    item.productData.construction &&
    Array.isArray(item.productData.construction.composition)
    ? item.productData.construction.composition.filter(part => part.type === type)
    : []
}

export const getTechnicalValues = (item, type) => {
  return item &&
    item.productData &&
    item.productData.technicalValues &&
    typeof item.productData.technicalValues[type] !== 'undefined'
    ? [item.productData.technicalValues[type].value]
    : []
}

const getCompositionPartValues = (item, type) => {
  const values = []

  const parts = getCompositionParts(item, type)
  parts.map(part => values.push(part.value))

  return values
}

const availables = {

  fill: ['scsb-18', 'scsb-30', 'scsb-40', 'scsb-50', 'scsb-60', 'scsb-65', 'scsb-80', 'scsb-120', 'us-65', 'scsb100-65', 'scsb100-105', null],

  fireResistance: ['F-30-B', null],

  heatTransferCoefficient: [0.16, 0.17, 0.18, 0.19, 0.20, 0.25, 0.26, 0.27, 0.28, 0.29, 0.31, 0.41, 0.42, 0.44, 0.45, 0.47, 0.48, 0.49, 0.50, 0.52, 0.55, 0.56],

  impactSoundLevel: [30, 31, 32, 33, 34, 35, 36, 37, 40, 41, 45, 46, 47, 48, 50, 51, 53, 54, 55, 56, 57, 58, 59, 61, 62],

  insulation: ['m-15', 'm-20', 'm-30', 'm-40', 'w-4', 'w-20', 'w-30', 'w-40'],

  screed: ['d-18', 'd-20', 'd-22', 'd-25', 'w-50', 'w-60', 'w-70', 'nw-0'],

  soundReductionIndex: [44, 58, 59, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 73, 75, 77, 78, 80, 81, 83, 84],

  supportingStructure: ['b-220', 'b-240', 'bs-220', 'mh-120', 'bsh-120'],

  suspendedCeiling: ['f-27', 'f-25', 'uas-80', 'ba-24', null], // 'h-100' , 'h-240', 'g-12.5'

  underfloorHeating: ['ufh-1', null],

  woodenPanel: [25, 22, null],

  soundInsulation: ['si-20', 'si-25', 'si-30', null]

}

export default availables

export const objMap = {

  fill: item => {
    const values = getCompositionPartValues(item, 'fill')
    return values.length > 0 ? values : [null]
  },

  fireResistance: item => getTechnicalValues(item, 'fireResistance'),

  heatTransferCoefficient: item => getTechnicalValues(item, 'heatTransferCoefficient'),

  impactSoundLevel: item => getTechnicalValues(item, 'impactSoundLevel'),

  insulation: item => getCompositionPartValues(item, 'insulation'),

  screed: item => getCompositionPartValues(item, 'screed'),

  soundReductionIndex: item => getTechnicalValues(item, 'soundReductionIndex'),

  supportingStructure: item => {
    const values = getCompositionPartValues(item, 'supportingStructure')
    if (values.indexOf('bs-220') >= 0 && values.indexOf('b-220') < 0) {
      values.push('b-220')
    }
    return values
  },

  suspendedCeiling: item => {
    const values = getCompositionPartValues(item, 'suspendedCeiling')
    return values.length > 0 ? values : [null]
  },

  underfloorHeating: item => {
    const values = getCompositionPartValues(item, 'underfloorHeating')
    return values.length > 0 ? values : [null]
  },

  soundInsulation: item => {
    const values = getCompositionPartValues(item, 'soundInsulation')
    return values.length > 0 ? values : [null]
  },

  woodenPanel: item => {
    const values = getCompositionPartValues(item, 'woodenPanel')
    return values.length > 0 ? values : [null]
  }

}

export const validate = (name, value) => {
  let result = []

  const values = availables[name] ? availables[name] : []
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      if (values.indexOf(value[i]) >= 0) result.push(value[i])
    }
  } else if (values.indexOf(value) >= 0) result = [value]

  return result
}
